import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import InstitutionsList from "./List";
import InstitutionForm from "./Form";
import Institution from "./View";
import NotFound from "../NotFound";

import { PageHeader } from "../Shared";

import { institutionActions } from "./actions/institutions.actions";

export class ManageInstitutions extends Component {
  componentDidMount() {
    this.getInstitutions();
  }

  getInstitutions = () => {
    this.props.getInstitutions();
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;

    return (
      <div className="Institutions">
        <Row>
          <Col>
            <PageHeader pageId="institutions" pageTitle="Manage Institutions" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <InstitutionsList
                  match={match}
                  data={response}
                  loadData={this.getInstitutions}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route
              path={`${match.url}/list`}
              render={() => (
                <InstitutionsList
                  match={match}
                  data={response}
                  loadData={this.getInstitutions}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route path={`${match.url}/add`} component={InstitutionForm} />
            <Route path={`${match.url}/view/:id`} component={Institution} />
            <Route path={`${match.url}/edit/:id`} component={InstitutionForm} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.institutions;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getInstitutions: bindActionCreators(
      institutionActions.getAllInstitutions,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageInstitutions);
